import { Component } from "react";
import { connect } from 'react-redux';

import { convertToFormatDate, isIsoDate, isValidFormattedDate } from "./../../../utils/helpers.utils";

class FormatDate extends Component {
    render() {
        const { date, activeDateFormat } = this.props;
        const isValidDate = isIsoDate(date) || isValidFormattedDate(date);

        return isValidDate ? convertToFormatDate(date, activeDateFormat.Name) : "";
    }
}

export default connect(
    state => {
        const { activeDateFormat } = state.adminSetting;
        return {
            activeDateFormat
        };
    }
)(FormatDate)